import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IFaqApiResponse, IFaqReqData } from '../../types/api/faqApi';
import { getFaqDataService } from '../../api/faqApi';
import { IFaqState } from '../../types/features/faqSlice';


export const getFaqData = createAsyncThunk<IFaqApiResponse, IFaqReqData>(
    'faq/getFaqData',
    async (data: IFaqReqData) => {
        const response = await getFaqDataService(data);
        return response.data; // Assumes response has a 'data' property
    }
);

const faqSlice = createSlice({
    name: 'faq',
    initialState: {
        faqLoader: false,
        status: false,
        msg: '',
        faq_data: []
    } as IFaqState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFaqData.pending, (state) => {
                state.faqLoader = true;
            })
            .addCase(getFaqData.fulfilled, (state, action: PayloadAction<IFaqApiResponse>) => {
                state.faq_data = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.faqLoader = false;
            })
            .addCase(getFaqData.rejected, (state, action) => {
                state.faqLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default faqSlice.reducer;
